import { useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'elements/Button';
import Loader from 'elements/Loader';
import { Container } from 'pages/Search/style';
import {
  fetchSearchResources,
  selectGlobalSearchResources,
  selectAllSearchResources,
  resetGlobalSearchResources,
} from '../ducks/resourceSlice';
import Resources from './Resources';

const SearchResources = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const query = searchParams.get('query') as string;

  const dispatch = useDispatch();

  const { isFetching, hasMore, total } = useSelector(
    selectGlobalSearchResources,
  );

  const resources = useSelector(selectAllSearchResources);

  const fetchMoreMembers = () => {
    dispatch(fetchSearchResources(query));
  };

  useEffect(() => {
    if (!query) {
      navigate('/dashboard');
    }

    dispatch(fetchSearchResources(query));

    return () => {
      dispatch(resetGlobalSearchResources());
    };
  }, [query, navigate, dispatch]);

  return (
    <Container>
      <Typography variant='h3' mb={4}>
        Search Results - Resources ({total})
      </Typography>

      {resources.length > 0 ? (
        <Box className='search-results'>
          <Resources resources={resources} />

          {hasMore && !isFetching ? (
            <div className='mt-30 text-center'>
              <Button className='mw120' variant='outlined' onClick={fetchMoreMembers}>
                Load More
              </Button>
            </div>
          ) : null}

          {isFetching ? (
            <div className='mt-30 text-center'>
              <Loader />
            </div>
          ) : null}
        </Box>
      ) : null}

      {resources.length <= 0 && isFetching ? (
        <div className='mt-30 text-center'>
          <Loader position='absolute' background='transparent' />
        </div>
      ) : null}
    </Container>
  );
};

export default SearchResources;
